<template>
  <div id="signin">
    <div class="signin-form">

    </div>
  </div>
</template>

<script>
  export default {
    created() {
      //console.log('created');
     // this.$router.push('/assemble')
      //window.location.href = process.env.VUE_APP_EPOS_API_BASE;
    },
    methods: {
      onRedirect() {
        //console.log('onRedirect');
       // this.$router.push('/assemble')
      }
    },
    mounted() {
     // this.onRedirect();
    }
  }
</script>
